import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the YapılanIslerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-yapilan-isler',
  templateUrl: 'yapilan-isler.html',
})
export class YapilanIslerPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
   
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/yapilan-isler/yapilan-isler.ts